import type { PeriodType, WeekStartDay } from '@/types/periods'

/**
 * Period type constants and labels
 */

export const PERIOD_TYPES: Record<PeriodType, string> = {
    weekly: 'Weekly',
    biweekly_even: 'Bi-Weekly (Even Weeks)',
    biweekly_odd: 'Bi-Weekly (Odd Weeks)',
    semi_monthly: 'Semi-Monthly (1st & 15th)',
    monthly: 'Monthly',
}

export const WEEK_DAY_NAMES: Record<WeekStartDay, string> = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
}

export const WEEK_DAY_NAMES_SHORT: Record<WeekStartDay, string> = {
    0: 'Sun',
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
}

export const DEFAULT_PERIOD_TYPE: PeriodType = 'weekly'
export const DEFAULT_WEEK_START_DAY: WeekStartDay = 1 // Monday
